var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogoutIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E82A53",
    d: "m14.047 4.974 4.078 4.112a1.303 1.303 0 0 1 0 1.828l-4.078 4.112a1.118 1.118 0 0 1-.796.331c-.621 0-1.126-.509-1.126-1.135v-2.08h-4.25a1.066 1.066 0 0 1-1.063-1.07V8.928c0-.593.475-1.072 1.063-1.072h4.25v-2.08c0-.625.505-1.134 1.126-1.134.298 0 .584.12.796.331Zm-7.235-.331H4.688c-.587 0-1.062.479-1.062 1.071v8.572c0 .592.475 1.071 1.063 1.071h2.125c.587 0 1.062.479 1.062 1.072 0 .592-.475 1.071-1.063 1.071H4.688c-1.76 0-3.187-1.44-3.187-3.214V5.714C1.5 3.94 2.928 2.5 4.688 2.5h2.125c.587 0 1.062.479 1.062 1.071 0 .593-.475 1.072-1.063 1.072"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogoutIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logout-icon.3c7c0d527e355d59fa80f87aa6a4804c.svg";